import { writable } from "svelte/store";

const { subscribe, set } = writable(false);

export const prompt = {
    subscribe,
    setPrompt : (type) => {
        const valid = {
            confirm : true,
            pending : true,
            success : true,
            failure : true,
            young   : true,
            expired : true
        };

        if (!valid[type]) {
            throw new Error("Invalid prompt type");
        }

        set(type);
    },
    clearPrompt : () => set(false)
};
